'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTransitionGroupCSSTransitionGroup = require('react-transition-group/CSSTransitionGroup');

var _reactTransitionGroupCSSTransitionGroup2 = _interopRequireDefault(_reactTransitionGroupCSSTransitionGroup);

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

var _Input = require('./Input');

var _Input2 = _interopRequireDefault(_Input);

var KEYCODES = {
    ENTER: 13,
    ESC: 27,
    UP: 38,
    DOWN: 40
};

var Dropdown = (function (_React$Component) {
    _inherits(Dropdown, _React$Component);

    function Dropdown(props) {
        _classCallCheck(this, Dropdown);

        _get(Object.getPrototypeOf(Dropdown.prototype), 'constructor', this).call(this, props);
        this.displayName = 'Dropdown';
        this.focusedRef = null;
        this.menuRef = null;
        this.state = {
            isOpen: this.props.isOpen || false,
            focusedOptionIndex: -1
        };
    }

    _createClass(Dropdown, [{
        key: 'openDropdown',
        value: function openDropdown() {
            this.setState({ isOpen: true });
        }
    }, {
        key: 'closeDropdown',
        value: function closeDropdown() {
            this.setState({ isOpen: false });
        }
    }, {
        key: 'navigateOptions',
        value: function navigateOptions(isUp) {
            var options = this.props.items || [];
            var currentIndex = this.state.focusedOptionIndex;

            if (!this.state.isOpen) {
                // if the key is DOWN & dropdown is closed, we need to open the dropdown
                if (!isUp) {
                    this.openDropdown();
                }
                return;
            }

            // if the current focused index is outside of the range of options, reset it
            if (currentIndex >= options.length) {
                currentIndex = -1;
            }

            var newIndex = undefined;

            if (!isUp && currentIndex < options.length - 1) {
                // move focused index down the list
                newIndex = currentIndex + 1;
            } else if (isUp && currentIndex >= 0) {
                // move focused index up the list
                newIndex = currentIndex - 1;
            } else if (currentIndex !== this.state.focusedOptionIndex) {
                // reset the index if needed
                newIndex = currentIndex;
            }

            // only update the state if a new index is needed
            if (typeof newIndex === 'number') {
                this.setState({
                    focusedOptionIndex: newIndex
                });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            // code taken from `Select`, in order to scroll the menu with keyboard navigation
            // when focus goes outside of the menu box's view
            if (this.state.isOpen && this.focusedRef && this.menuRef) {
                var focusedRect = this.focusedRef.getBoundingClientRect(),
                    menuRect = this.menuRef.getBoundingClientRect();

                if (focusedRect.bottom > menuRect.bottom) {
                    this.menuRef.scrollTop = this.focusedRef.offsetTop + this.focusedRef.clientHeight - this.focusedRef.clientHeight;
                } else if (focusedRect.top < menuRect.top) {
                    this.menuRef.scrollTop = this.focusedRef.offsetTop;
                }
            }
        }
    }, {
        key: 'handleKeyDown',
        value: function handleKeyDown(e) {
            var keyCode = e && e.keyCode;
            switch (keyCode) {
                case KEYCODES.ESC:
                    {
                        if (this.state.isOpen) {
                            this.closeDropdown();
                        }
                        break;
                    }
                // adding these below cases to support keyboard accessibility
                case KEYCODES.UP:
                    {
                        e.preventDefault();
                        this.navigateOptions(true);
                        break;
                    }
                case KEYCODES.DOWN:
                    {
                        e.preventDefault();
                        this.navigateOptions(false);
                        break;
                    }
                case KEYCODES.ENTER:
                    {
                        e.preventDefault();
                        if (this.state.isOpen && this.state.focusedOptionIndex >= 0) {
                            this.onClick(this.props.items[this.state.focusedOptionIndex].value);
                            this.closeDropdown();
                        }
                        break;
                    }
                default:
                // do nothing
            }
        }
    }, {
        key: 'renderChildren',
        value: function renderChildren() {
            var _this = this;

            return _react2['default'].Children.map(this.props.children, function (child) {
                var inputElementARIAProps = {};
                // if the child is an `Input` then we can apply the combobox ARIA attributes to it
                if (child && child.type === _Input2['default']) {
                    var activeDescendant = _this.state.focusedOptionIndex >= 0 ? _this.props.id + '-item-' + _this.state.focusedOptionIndex : '';
                    inputElementARIAProps = {
                        'aria-owns': _this.props.id,
                        'role': 'combobox',
                        'aria-haspopup': true,
                        'aria-autocomplete': 'list',
                        'aria-expanded': _this.state.isOpen,
                        'aria-activedescendant': activeDescendant
                    };
                }

                return _react2['default'].cloneElement(child, _extends({
                    onFocus: function onFocus() {
                        _this.openDropdown.bind(_this)();
                        if (child.props.onFocus) {
                            child.props.onFocus();
                        }
                    },
                    onBlur: function onBlur() {
                        // adding this so that on a tab off the component, dropdown will not still be open
                        _this.closeDropdown.bind(_this)();
                        if (child.props.onBlur) {
                            child.props.onBlur();
                        }
                    },
                    onKeyDown: function onKeyDown(e) {
                        _this.handleKeyDown.bind(_this)(e);
                        if (child.props.onKeyDown) {
                            child.props.onKeyDown(e);
                        }
                    },
                    className: (0, _classnames2['default'])(child.props.className, 'Dropdown-toggle')
                }, inputElementARIAProps));
            });
        }
    }, {
        key: 'renderButton',
        value: function renderButton() {
            var disclosureArrow = this.props.buttonHasDisclosureArrow ? _react2['default'].createElement('span', { className: 'disclosure-arrow' }) : null;

            return _react2['default'].createElement(
                _Button2['default'],
                {
                    type: this.props.buttonType,
                    onClick: this.state.isOpen ? this.closeDropdown.bind(this) : this.openDropdown.bind(this),
                    className: 'Dropdown-toggle'
                },
                this.props.buttonLabel,
                disclosureArrow
            );
        }
    }, {
        key: 'onClick',
        value: function onClick(selectedItem) {
            this.setState({
                isOpen: !this.state.isOpen
            });

            this.props.onSelect(selectedItem);
        }
    }, {
        key: 'renderDropdownMenu',
        value: function renderDropdownMenu() {
            var _this2 = this;

            var self = this;
            if (!this.state.isOpen || !this.props.items.length) return null;

            var dropdownMenuItems = [];

            if (this.props.items) {
                dropdownMenuItems = this.props.items.map(function (item, i) {
                    var focusedIndex = self.state.focusedOptionIndex;
                    var focusedOption = self.props.items[focusedIndex];
                    var focused = focusedOption && focusedOption.value === item.value;
                    var menuItem = undefined;
                    if (item.type === 'header') {
                        menuItem = _react2['default'].createElement(
                            'li',
                            { key: 'item-' + i, className: 'Dropdown-menu__header' },
                            item.label
                        );
                    } else if (item.type === 'divider') {
                        menuItem = _react2['default'].createElement('li', { key: 'item-' + i, className: 'Dropdown-menu__divider' });
                    } else if (item.type === 'info') {
                        menuItem = _react2['default'].createElement(
                            'li',
                            { key: 'item-' + i, className: 'Dropdown-menu__info' },
                            item.label
                        );
                    } else {
                        menuItem = _react2['default'].createElement(
                            'li',
                            { key: 'item-' + i, id: self.props.id + '-item-' + i, role: 'option', className: 'Dropdown-menu__item', ref: function (ref) {
                                    if (focused) {
                                        self.focusedRef = ref;
                                    }
                                }, 'aria-selected': focused },
                            _react2['default'].createElement(
                                'span',
                                {
                                    className: (0, _classnames2['default'])('Dropdown-menu__action', {
                                        'Dropdown-menu__action_focused': focused
                                    }),
                                    onMouseDown: self.onClick.bind(self, item.value)
                                },
                                item.label
                            )
                        );
                    }
                    return menuItem;
                });
            }

            return _react2['default'].createElement(
                'ul',
                { id: this.props.id, key: 'Dropdown-menu', className: 'Dropdown-menu', 'aria-label': this.props.label, role: 'listbox', ref: function (ref) {
                        _this2.menuRef = ref;
                    } },
                dropdownMenuItems
            );
        }
    }, {
        key: 'renderDropdownMenuBackground',
        value: function renderDropdownMenuBackground() {
            if (!this.state.isOpen) return null;
            return _react2['default'].createElement('div', { className: 'Dropdown-menu-backdrop', onClick: this.closeDropdown.bind(this) });
        }
    }, {
        key: 'render',
        value: function render() {
            // classes
            var dropdownClass = (0, _classnames2['default'])('Dropdown', {
                'is-open': this.state.isOpen,
                'align-right': this.props.alignRight
            }, this.props.className);

            // props
            var props = (0, _blacklist2['default'])(this.props, 'alignRight', 'buttonHasDisclosureArrow', 'buttonLabel', 'buttonType', 'className', 'isOpen', 'items', 'onSelect');

            return _react2['default'].createElement(
                'span',
                _extends({ className: dropdownClass }, props),
                _react2['default'].Children.count(this.props.children) ? this.renderChildren() : this.renderButton(),
                _react2['default'].createElement(
                    _reactTransitionGroupCSSTransitionGroup2['default'],
                    {
                        transitionName: 'Dropdown-menu',
                        transitionEnterTimeout: 100,
                        transitionLeaveTimeout: 100
                    },
                    this.renderDropdownMenu()
                ),
                this.renderDropdownMenuBackground()
            );
        }
    }]);

    return Dropdown;
})(_react2['default'].Component);

var item = _propTypes2['default'].shape({
    label: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
    value: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].node]),
    type: _propTypes2['default'].oneOf(['header', 'divider', 'info'])
});

Dropdown.propTypes = {
    alignRight: _propTypes2['default'].bool,
    buttonHasDisclosureArrow: _propTypes2['default'].bool,
    buttonLabel: _propTypes2['default'].string,
    buttonType: _propTypes2['default'].string,
    children: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].array]),
    className: _propTypes2['default'].string,
    isOpen: _propTypes2['default'].bool,
    items: _propTypes2['default'].arrayOf(item),
    onSelect: _propTypes2['default'].func
};

Dropdown.defaultProps = {
    buttonHasDisclosureArrow: true,
    onSelect: function onSelect() {}
};

module.exports = Dropdown;
/* use onMouseDown instead of onClick below to ensure that the click
   event handler is called before onBlur hides the dropdown menu
   https://stackoverflow.com/a/10653160 */


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/Dropdown.js
// module id = 284
// module chunks = 0